import React from 'react';
import { FormSectionContainer as Container } from 'components/styled-components';
import { Icon } from '@blueprintjs/core';
import Dropzone from 'react-dropzone';
import styled from 'styled-components';
import colors from 'utils/colors';

const rejectedState = {
  borderStyle: 'solid',
  borderColor: '#c66',
  backgroundColor: '#eee',
};
const disabledState = {
  opacity: 0.5,
  cursor: 'no-drop',
};
const activeState = {
  borderStyle: 'solid',
  borderColor: '#6c6',
  backgroundColor: '#eee',
};

const acceptState = {
  borderStyle: 'solid',
  borderColor: '#6c6',
  backgroundColor: '#eee',
};
const defaultState = {
  width: '100%',
  minHeight: 50,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 20,
  cursor: 'pointer',
};

const AddAttachmentsSection = props => (
  <Container>
    <Dropzone
      onDrop={props.handleOnDrop}
      style={defaultState}
      activeStyle={activeState}
      disabledStyle={disabledState}
      rejectStyle={rejectedState}
      acceptStyle={acceptState}
    >
      {({ getRootProps, getInputProps }) => (
        <section>
          <DropzoneWrapper {...getRootProps()}>
            <input {...getInputProps()} />
            <Icon
              icon="folder-shared-open"
              color={colors.lightGray}
              iconSize={16}
              style={{ marginRight: '0.25rem' }}
            />
            <TextWrapper>Drop files to attach or</TextWrapper>
            <BrowseLink>browse.</BrowseLink>
          </DropzoneWrapper>
        </section>
      )}
    </Dropzone>
    <ul>
      {props.attachments.map((f, index) => (
        <Attachments key={index}>
          <StyledIcon
            icon="trash"
            onClick={() => props.handleAttachmentRemove(f)}
          />
          <Li>{f.name} </Li>
        </Attachments>
      ))}
    </ul>
  </Container>
);
const DropzoneWrapper = styled.div`
  border: 2px dashed #ccc;
  border-radius: 5px;
  padding: 2rem;
  height: 100%;
  &:hover {
    cursor: pointer;
    border-color: ${colors.primary};
  }
`;
const BrowseLink = styled.span`
  text-decoration: underline;
  color: ${colors.primary};
`;

const TextWrapper = styled.span`
  margin: 0 3px;
`;
const StyledIcon = styled(Icon)`
  &:hover {
    color: ${colors.darkRed};
    cursor: pointer;
  }
`;
const Li = styled.li`
  list-style-type: none;
  padding-left: 5px;
`;

const Attachments = styled.div`
  display: flex;
  & ${StyledIcon}:hover ~ ${Li} {
    color: ${colors.darkRed};
    text-decoration: line-through;
    font-style: italic;
  }
`;

export default AddAttachmentsSection;
